import React, { useEffect, useState } from 'react';
import { Fingerprint, Loader2, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { errMsg } from './api';
import { KEY, canUseBiometric, enroll } from './biometric';

// Biometric devices of the account: list, add this device, remove.
export default function PasskeyList({ client, base, who }) {
  const [rows, setRows] = useState(null);
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = () => client.get(base).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); canUseBiometric().then(setOk); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const add = async () => {
    setBusy(true);
    try { await enroll(client, base); localStorage.setItem(KEY(who), 'on'); toast.success('Accesso biometrico attivato'); load(); }
    catch (e) { if (e?.name === 'InvalidStateError') { localStorage.setItem(KEY(who), 'on'); toast.info('Accesso biometrico già attivo su questo dispositivo'); } else if (e?.name !== 'NotAllowedError') toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const del = async (p) => {
    if (!window.confirm(`Disattivare l'accesso biometrico su ${p.label}?`)) return;
    try { await client.delete(`${base}/${p.id}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-3" data-testid="passkey-list">
      <div className="flex items-center gap-4"><Fingerprint className="text-[#D4AF37]" size={20} /><div className="flex-1"><p className="text-sm">Impronta, Face ID o Windows Hello</p><p className="text-xs text-[#5A5F67]">Sostituisce il codice; il codice resta come riserva</p></div>
        <span className={`text-xs ${rows?.length ? 'text-[#5FC18F]' : 'text-[#7A7F87]'}`} data-testid="passkey-status">{rows?.length ? `${rows.length} dispositivi` : 'Non attivo'}</span></div>
      {(rows || []).map((p) => (
        <div key={p.id} className="flex items-center gap-3 text-xs pl-9" data-testid={`passkey-row-${p.id}`}>
          <span className="flex-1">{p.label} · dal {new Date(p.created_at).toLocaleDateString('it-IT')}{p.last_used ? ` · ultimo uso ${new Date(p.last_used).toLocaleDateString('it-IT')}` : ''}</span>
          <button onClick={() => del(p)} className="text-[#7A7F87] hover:text-[#E5484D]" data-testid={`passkey-delete-${p.id}`}><Trash2 size={14} /></button>
        </div>
      ))}
      {ok ? <button onClick={add} disabled={busy} className="ml-9 text-sm text-[#D4AF37] inline-flex items-center gap-2 hover:underline" data-testid="passkey-add">{busy ? <Loader2 size={14} className="animate-spin" /> : <Fingerprint size={14} />}Attiva su questo dispositivo</button>
        : <p className="text-xs text-[#5A5F67] pl-9">Questo dispositivo o browser non supporta l'accesso biometrico.</p>}
    </div>
  );
}
